/*
 * @Author: gaobin
 * @Date: 2025-04-24 16:36:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-05-15 11:28:37
 * @Description: 聊天室
 */
const chartMap = {
  // 发送聊天消息
  sendChartMessageExt: '/fanscrm/scrm/web/v1/chat/sendGroupMsg',
  // 获取用户群聊id
  selectGroupId: '/fanscrm/scrm/web/v1/chat/selectGroupId',
  // 查询goeasy消息列表
  queryGoEasyMessageListExt: '/fanscrm/scrm/web/v1/chat/selectGroupMsgPage',
  // 获取用户群聊id
  selectGroupIdExt: '/fanscrm/scrm/web/v1/chat/selectGroupId',
  // 用户列表
  selectServiceUserExt: '/fanscrm/scrm/web/v1/chat/selectServiceUser',
  // 获取客户id
  getCustomerUserId: '/fanscrm/scrm/web/v1/chat/getCustomerUserId',
  // 通知后端订阅goeasy消息
  subChatExt: '/fanscrm/scrm/web/v1/chat/subscribeGroups',
  // 通知后端取消订阅goeasy消息
  unSubscribeGroupsExt: '/fanscrm/scrm/web/v1/chat/unSubscribeGroups',
  // 获取群组id
  getSubscribeGroupsExt: '/fanscrm/scrm/web/v1/chat/getSubscribeGroups',
};

export default chartMap;
